import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

/*** components ***/
import StepStatus from "../../../components/CarentPageComponents/StepStatus";
import DrawArea from './DrawArea';
import OptionArea from './OptionArea';

/***actions ***/
import {pushBuildValue} from "../../../actions/pushBuildValue";

/*** styles ***/
import './style2.css';

class Step1 extends Component{
       changeInputValue = (e) => {
        let value = e.target.value,
              id = e.target.dataset.inputName;
        if( id === "wall-width" && (+value*2 > this.props.width || +value*2 > this.props.length)){
            /*** show error ***/
        }
        if(e.target.type === "checkbox"){
            value = !this.props.buildValues[id];
        }
        if(e.target.type ==="number" && (+e.target.value > 0)){
                this.props.pushBuildValue({[id]: value});
        }else{
            this.props.pushBuildValue({[id] : value});
        }
    };
    render(){
        return(
            <main className={"step-1"}>
                <StepStatus
                    isDirect = {this.props.buildValues.isVisitedFinish}
                />
                <DrawArea changeInputValue = {this.changeInputValue}/>
                <OptionArea changeInputValue = {this.changeInputValue}/>
            </main>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        buildValues : state.buildValues
    }
};

const mapStateToDispatch = {
    pushBuildValue
};

export default  withRouter(connect(mapStateToProps, mapStateToDispatch)(Step1));



// WEBPACK FOOTER //
// ./src/containers/steps/step1/index.js